import { call, restService } from './apiHelpers';

export const notificationService = {
  ...restService('notifications'),
  getUnreadByUser: () => call('get', 'notifications/', null, { read: false }),
  getByUser: () => call('get', 'notifications/'),
  getUnreadCount: () => call('get', 'notifications/unread-count/'),
  markAsRead: (id) => call('post', `notifications/${id}/read/`, {}),
  markAllAsRead: () => call('post', 'notifications/read-all/', {}),
};
